/*
 * @Author: chj
 * @Date: 2024-10-10 11:13:47
 * @LastEditors: chj
 * @LastEditTime: 2024-10-18 15:47:42
 * @Description: 请填写简介
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home/index.vue";
import store from "../store";
import { message } from "ant-design-vue";
import { getToken } from "@/utils/auth";
import { getMenuList } from "@/api/menu";

Vue.use(VueRouter);

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      name: '首页'
    },
  },
  {
    path: "/center",
    name: "center",
    meta: {
      nav: false,
      name: '用户中心'
    },
    component: () =>
      import(/* webpackChunkName: "center" */ "../views/Center/index.vue"),
  },
  {
    path: "/list/:type/:id",
    name: "listDetail",
    meta: {
      nav: false,
      name: '详情'
    },
    component: () =>
      import(/* webpackChunkName: "listDetail" */ "../views/Cms/detail.vue"),
  },
  {
    path: "/product/:id",
    name: "productDetail",
    meta: {
      nav: false,
      name: '详情'
    },
    component: () =>
      import(/* webpackChunkName: "productDetail" */ "../views/Product/detail.vue"),
  },
  {
    path: "/detail/:id",
    name: "committeeDetail",
    meta: {
      nav: false,
      name: '详情'
    },
    component: () =>
      import(/* webpackChunkName: "CommitteeDetail" */ "../views/Committee/detail.vue"),
  },
];

export const afterRoutes = [
  {
    path: "/document/:path*",
    name: "document",
    meta: {
      name: '联盟文档'
    },
    component: () =>
      import(/* webpackChunkName: "document" */ "../views/Document/index.vue"),
  },
  {
    path: "/account",
    name: "account",
    meta: {
      name: '会员登录'
    },
    component: () =>
      import(/* webpackChunkName: "account" */ "../views/Login/index.vue"),
  },
]

const parentComponent = () => import(/* webpackChunkName: "parent" */ "@/views/Parent/index.vue");

const routeType = {
  'list': () => import(/* webpackChunkName: "list" */ "@/views/Cms/list.vue"),
  'article': () => import(/* webpackChunkName: "article" */ "@/views/Cms/detail.vue"),
  'product': () => import(/* webpackChunkName: "product" */ "@/views/Product/index.vue"),
  'committee': () => import(/* webpackChunkName: "committee" */ "@/views/Committee/index.vue"),
}

const transformRoute = (routeData, child = false) => {

  // 动态导入组件
  const route = {
    path: child ? routeData.menu_route : `/${routeData.menu_route}`,
    name: routeData.menu_route,
    meta: {
      name: routeData.name,
      nav: child ? false: true,
      type: routeData.menu_remark,
      id: routeData.id,
    },
  };

  // 如果有子路由，递归处理 children
  if (routeData.childrenMenu && routeData.childrenMenu.length > 0) {
    route.component = parentComponent
    route.children = routeData.childrenMenu.map(child => transformRoute(child, true));
  } else {
    if (routeData.menu_remark == 'link') {
      route.link = routeData.menu_route
    } else {
      route.component = routeType[routeData.menu_remark]
    }
  }

  return route;
}


// 动态添加路由方法
const addDynamicRoutes = async() => {
  try {
    const { data } = await getMenuList({ state: 1 });
    const routes = []
    data.forEach(routeData => {
      const route = transformRoute(routeData);
      routes.push(route)
      router.addRoute(route);
    });
    afterRoutes.forEach(route => {
      router.addRoute(route)
    })
    console.log('routes', routes)
    store.dispatch('setNavRouters', routes)
  } catch (error) {
      console.error("加载路由失败:", error);
  }
}

addDynamicRoutes()

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果返回浏览器的历史记录，则滚动到之前的位置
      return savedPosition;
    } else {
      // 否则滚动到页面顶部
      return { x: 0, y: 0 };
    }
  },
})

const blockList = ["/document"];

router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (to.path === "/account") {
      next({ path: "/" });
    } else if (blockList.indexOf(to.path) == -1) {
      if (store.state.user.id) {
        next();
      } else {
        store
          .dispatch("GetInfo")
          .then(() => {
            next();
          })
          .catch((err) => {
            store.dispatch("LogOut").then(() => {
              message.error(err);
              next({ path: "/" });
            });
          });
      }
    } else {
      if (store.state.user.id) {
        next();
      } else {
        store
          .dispatch("GetInfo")
          .then(() => {
            next();
          })
          .catch((err) => {
            store.dispatch("LogOut").then(() => {
              message.error(err);
              next({ path: "/" });
            });
          });
      }
    }
  } else {
    // 没有token
    if (blockList.indexOf(to.path) == -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next(`/account`); // 否则全部重定向到登录页
    }
  }
});

export default router;
